// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4989":"f483ec4d08c89c19f577","9249":"621b8ee34ff0114fea78"}[chunkId] + ".chunk.js";
};